import { projectsControllerListProjects } from '@artic/api-client';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export interface ProjectListItem {
  project_id: string;
  project_name: string;
  project_code: string;
  project_prefix: string | null;
  is_archived: boolean;
}

export const PROJECTS_KEY = 'projects' as const;

/**
 * Lightweight per-partner project list, used by the partner-wide Work Orders
 * grid to format the per-row Project column (cells store project_id but
 * render the project_name). Cached 60 s and reused across features.
 */
export function projectsQueryOptions(partnerId: string | undefined) {
  return queryOptions({
    queryKey: [PROJECTS_KEY, 'list', partnerId] as const,
    queryFn: async ({ signal }) => {
      const res = await projectsControllerListProjects({ partner_id: partnerId ?? '' }, { signal });
      return res.data as ProjectListItem[];
    },
    enabled: !!partnerId,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
